import { useEffect, useState } from "react";
import { request } from "../../../request";
import CreatableSelect from "react-select/creatable";
import Swal from "sweetalert2";
import Premissions from "./Premissions";

const AddUser = ({ darkMode, updateUsers, isOpen, texts }) => {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [showAddCustomer, setShowAddCustomer] = useState(false);
    const [values, setValues] = useState();

    const addUser = () => {
        setShowAddCustomer((e) => !e);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await request.post("/user/register", {
                username,
                email,
                premissions: values,
            });
            Swal.fire({
                title: "User added successfully",
                icon: "success",
            });
            setShowAddCustomer(false);
            updateUsers();
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        request.get("/user/premissions").then((res) => {
            setValues(res.data);
        });
    }, []);

    return (
        <div>
            {isOpen ? (
                <div
                    className="container mx-auto p-6 max-w-[900px] bg-white border border-gray-300 rounded-lg shadow-lg"
                    style={{
                        backgroundColor: darkMode ? "#141619" : "white",
                    }}
                >
                    <form className="mb-4" onSubmit={handleSubmit}>
                        <div className="flex flex-col mb-4">
                            <label
                                className="text-lg mb-2"
                                htmlFor="name"
                                style={{
                                    color: darkMode ? "white" : "black",
                                }}
                            >
                                {texts.user.username}
                            </label>
                            <input type="text" id="name" value={username} onChange={(e) => setUsername(e.target.value)} className="border p-2 rounded" placeholder={texts.user.enterUsername} required />
                        </div>
                        <div className="flex flex-col mb-4">
                            <label
                                className="text-lg mb-2"
                                htmlFor="value"
                                style={{
                                    color: darkMode ? "white" : "black",
                                }}
                            >
                                Email
                            </label>
                            <input type="email" id="contact" value={email} onChange={(e) => setEmail(e.target.value)} className="border p-2 rounded" placeholder="Email" required />
                        </div>
                        <div className="flex flex-col mb-4">
                            <Premissions values={values} setValues={setValues} texts={texts} />
                        </div>
                        <button
                            type="submit"
                            className="flex min-w-[84px] max-w-[480px] mt-4 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-gray-200 text-[#111418] text-sm font-bold leading-normal tracking-[0.015em]"
                            style={{
                                backgroundColor: darkMode ? "#FEC901" : "#FEC901",
                            }}
                        >
                            {texts.user.addUser}
                        </button>
                    </form>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default AddUser;
